/*
SLB FEATURE ASSET
Feature: AC FU Request
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Release: V73
*/
/*
  SLB AC FU Request V73
  Clean standalone rebuild. The disciple-facing app lives in a Shadow DOM and
  uses a new host element, so old Temple page code and global SLB dark-mode CSS
  cannot repaint or restyle it.
*/
(function(window, document){
  'use strict';

  var VERSION = 'V73';
  var HOST_TAG = 'slb-ac-fu-request-v72';
  var BACKGROUND = 'https://cdn.shopify.com/s/files/1/1299/3411/files/ChatGPT_Image_Jul_30_2026_09_30_26_PM.png?v=1785461436';
  var CACHE_KEY = 'slb_ac_fu_catalog_v72';
  var PREF_KEY = 'slb_ac_fu_preferences_v72';

  function text(v){ return String(v == null ? '' : v); }
  function clean(v){ return text(v).trim(); }
  function esc(v){
    return text(v).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function num(v){ var n = Number(v); return Number.isFinite(n) ? n : 0; }
  function fmt(v){ return Math.round(num(v)).toLocaleString(); }
  function app(){
    try { return window.SLB_APP || window.SLBAPP || window.SLB || window.slbApp || null; }
    catch(_e){ return null; }
  }
  function unwrap(out){
    if(out && typeof out === 'object'){
      if(out.ok === false) throw new Error(out.error || out.message || 'Request failed.');
      if(out.result != null) return out.result;
      if(out.data != null) return out.data;
    }
    return out;
  }
  function waitForApp(timeoutMs){
    timeoutMs = Number(timeoutMs || 30000);
    var started = Date.now();
    return new Promise(function(resolve,reject){
      (function check(){
        var a = app();
        if(a && typeof a.rpc === 'function'){ resolve(a); return; }
        if(Date.now() - started >= timeoutMs){ reject(new Error('SLB connection is not ready.')); return; }
        setTimeout(check, 160);
      })();
    });
  }
  function rpc(action, args, opts){
    return waitForApp((opts && opts.timeoutMs) || 30000).then(function(a){
      return a.rpc(action, args || {}, opts || {}).then(unwrap);
    });
  }
  function libraryData(){
    return window.TYD_LIBRARY_BOOTSTRAP_V140 || window.TYD_LIBRARY_BOOTSTRAP_V132 || null;
  }
  function fuCode(row){
    row = row || {};
    var source = [row.image_caption,row.image_alt,row.title,row.english_title,row.chinese_title,row.item_id].join(' ');
    var match = source.match(/\b([A-Z]{1,6}\d{1,4})\b/i);
    if(match && match[1]) return match[1].toUpperCase();
    var first = clean(row.item_id).split('_')[0].replace(/[^A-Za-z0-9]/g,'');
    return first ? first.toUpperCase() : 'FU';
  }
  function localCatalog(){
    var d = libraryData();
    if(!d || !Array.isArray(d.items) || !d.items.length) return [];

    var fuBooks = Object.create(null);
    var bookTitle = Object.create(null);
    var bookOrder = Object.create(null);
    (Array.isArray(d.books) ? d.books : []).forEach(function(book){
      book = book || {};
      var id = clean(book.book_id);
      var title = clean(book.book_title_english || book.english_title || book.title || book.directory_group || book.category_group || id);
      var isFu = clean(book.library_type || book.type).toUpperCase() === 'FU';
      if(id){ bookTitle[id] = title || id; bookOrder[id] = num(book.display_order) || 999999; }
      if(isFu){ if(id) fuBooks[id] = true; if(title) fuBooks[title] = true; }
    });

    var indexByItem = Object.create(null);
    (Array.isArray(d.index) ? d.index : []).forEach(function(entry){
      entry = entry || {};
      var itemId = clean(entry.item_id);
      var bookId = clean(entry.book_id);
      var source = clean(entry.source_book || bookTitle[bookId] || '');
      if(itemId && (fuBooks[bookId] || fuBooks[source])){
        indexByItem[itemId] = {
          bookId: bookId,
          sourceBook: source || bookTitle[bookId] || 'FU Library',
          order: bookOrder[bookId] || 999999
        };
      }
    });

    var seen = Object.create(null);
    var out = [];
    d.items.forEach(function(row, index){
      row = row || {};
      var libraryItemId = clean(row.item_id);
      var indexed = indexByItem[libraryItemId] || null;
      var directBook = clean(row.first_source_book || row.source_book || '');
      var category = clean(row.category || row.category_group || row.directory_group || 'FU');
      var isFu = clean(row.type || row.library_type).toUpperCase() === 'FU' || !!indexed || !!fuBooks[directBook] || !!fuBooks[category];
      if(!isFu) return;
      var status = clean(row.status || 'active').toLowerCase();
      if(/^(inactive|archived|draft|hidden|disabled)$/.test(status)) return;

      var code = fuCode(row);
      var key = (libraryItemId || code).toUpperCase();
      if(!key || seen[key]) return;
      seen[key] = true;

      var chinese = clean(row.chinese_title || row.title_chinese);
      var english = clean(row.english_title || row.title_english || row.title);
      var purpose = clean(row.notes || row.purpose || row.description || row.details || row.blurb || row.short_summary || row.simple_meaning || row.what_it_does || row.practice_usage);
      var image = clean(row.image_url || row.imageUrl || row.image_src || row.image_link || row.artwork_url || row.media_url);
      var sourceBook = clean(directBook || (indexed && indexed.sourceBook) || category || 'FU Library');
      var title = [code, english, chinese].filter(Boolean).join(' · ');
      out.push({
        itemId: code,
        libraryItemId: libraryItemId,
        code: code,
        englishTitle: english || 'FU',
        chineseTitle: chinese,
        title: title,
        purpose: purpose,
        imageUrl: image,
        imageAlt: clean(row.image_alt || row.image_caption || title),
        sourceBook: sourceBook,
        category: category,
        sortOrder: num(indexed && indexed.order) * 10000 + index,
        fixedPrice: 108
      });
    });

    out.sort(function(a,b){
      var ao = num(a.sortOrder), bo = num(b.sortOrder);
      if(ao !== bo) return ao - bo;
      return text(a.code).localeCompare(text(b.code), 'en', {numeric:true, sensitivity:'base'});
    });
    return out;
  }
  function libraryVersion(){
    var d = libraryData() || {};
    return ['SAAM_LAW_LIBRARY', d.v || '', d.savedAt || d.generatedAt || '', (d.items || []).length].join('_');
  }
  function readJson(key, fallback){
    try { var value = JSON.parse(localStorage.getItem(key) || 'null'); return value == null ? fallback : value; }
    catch(_e){ return fallback; }
  }
  function writeJson(key, value){ try { localStorage.setItem(key, JSON.stringify(value)); } catch(_e){} }

  function pouchIdOf(pouch){
    pouch = pouch || {};
    return clean(pouch.accountId || pouch.walletId || pouch.account_id || pouch.wallet_id || pouch.id);
  }
  function normalizePouches(value){
    var rows = [];
    if(Array.isArray(value)) rows = value;
    else if(value && typeof value === 'object'){
      rows = value.pouches || value.accounts || value.items || value.rows || [];
      if(!Array.isArray(rows)) rows = [];
    }
    var seen = Object.create(null), out = [];
    rows.forEach(function(raw){
      raw = raw || {};
      var id = pouchIdOf(raw);
      if(!id || seen[id.toLowerCase()]) return;
      var status = clean(raw.status || 'ACTIVE').toUpperCase();
      var kind = clean(raw.kind || raw.type || '').toUpperCase();
      var sealed = String(raw.sealed == null ? '0' : raw.sealed);
      if(status && status !== 'ACTIVE' && status !== 'ENABLED') return;
      if(sealed === '1' || /^TRUE$/i.test(sealed)) return;
      if(kind === 'ON_HAND' || kind === 'WALLET' || /^w_/i.test(id)) return;
      if(!/^a_/i.test(id)) return;
      seen[id.toLowerCase()] = true;
      out.push({
        accountId:id, walletId:clean(raw.walletId || raw.wallet_id),
        name:clean(raw.name || raw.label || raw.accountName || raw.account_name || 'Cosmic Pouch'),
        balance:num(raw.balance != null ? raw.balance : (raw.stones != null ? raw.stones : raw.amount)),
        status:status || 'ACTIVE', kind:kind || 'POUCH'
      });
    });
    out.sort(function(a,b){ return text(a.name).localeCompare(text(b.name),'en',{numeric:true,sensitivity:'base'}); });
    return out;
  }
  function pouchesFromApp(){
    var a = app(), candidates = [];
    try{ if(a && a.S && a.S.dash) candidates.push(a.S.dash.accounts, a.S.dash.pouches); }catch(_e1){}
    try{ if(a) candidates.push(a.pouches, a.accounts); }catch(_e2){}
    try{ if(window.SLB_STATE) candidates.push(window.SLB_STATE.accounts, window.SLB_STATE.pouches); }catch(_e3){}
    for(var i=0;i<candidates.length;i++){ var rows = normalizePouches(candidates[i]); if(rows.length) return rows; }
    return [];
  }

  var STYLE = String.raw`
    :host{
      --gold:#ffd966; --gold2:#fff0ad; --ink:#2d1633; --purple:#4d155d;
      display:block; width:100%; min-width:0; color:#fff; container-type:inline-size;
      font-family:system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif;
    }
    *{box-sizing:border-box}
    button,input,select,textarea{font:inherit}
    button{cursor:pointer}
    button:disabled{cursor:not-allowed;opacity:.58}
    .scene{
      position:relative; width:100%; min-height:720px;
      height:min(900px,max(720px,calc(100dvh - 22px)));
      overflow:hidden; border-radius:24px; isolation:isolate;
      border:1px solid rgba(255,224,133,.55);
      background-position:center; background-size:cover;
      box-shadow:0 22px 58px rgba(14,2,23,.48),inset 0 0 72px rgba(27,3,42,.48);
    }
    .scene::before{content:"";position:absolute;inset:0;z-index:-2;background:linear-gradient(180deg,rgba(22,4,34,.30),rgba(35,5,48,.67) 54%,rgba(15,2,24,.84))}
    .scene::after{content:"";position:absolute;inset:0;z-index:-1;pointer-events:none;background:radial-gradient(circle at 54% 36%,rgba(255,229,129,.13),transparent 34%),radial-gradient(circle at 13% 18%,rgba(222,106,255,.16),transparent 28%)}
    .header{position:absolute;z-index:20;left:20px;right:20px;top:14px;display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
    .kicker{font-size:10px;font-weight:950;letter-spacing:.16em;text-transform:uppercase;color:#ffe69a;text-shadow:0 2px 8px #000}
    h1{margin:3px 0 0;font:900 clamp(28px,4vw,44px)/1 Georgia,"Times New Roman",serif;color:#fff2c2;text-shadow:0 3px 12px rgba(0,0,0,.8)}
    .controls{display:flex;padding:0;border:0;border-radius:0;background:transparent;backdrop-filter:none}
    .icon-btn{width:42px;height:42px;border:0;border-radius:50%;background:transparent;color:#fff3ca;font-size:20px;font-weight:950;box-shadow:none;text-shadow:0 2px 10px rgba(0,0,0,.75);transition:transform .14s ease,color .14s ease,filter .14s ease}
    .icon-btn:hover{background:transparent;color:#fff8dc;box-shadow:none;transform:scale(1.1);filter:drop-shadow(0 0 8px rgba(255,224,120,.8))}
    .price-badge{position:absolute;z-index:18;left:20px;top:76px;padding:7px 12px;border:1px solid rgba(255,232,149,.58);border-radius:999px;background:rgba(76,20,89,.86);color:#fff0a5;font-size:10px;font-weight:950;letter-spacing:.08em}
    .layout{position:absolute;left:16px;right:16px;top:112px;bottom:16px;display:grid;grid-template-columns:minmax(270px,.72fr) minmax(0,1.58fr);gap:13px;min-width:0;min-height:0}
    .panel{min-width:0;min-height:0;border:0;border-radius:21px;background:linear-gradient(180deg,rgba(39,7,51,.84),rgba(20,3,30,.88));box-shadow:0 14px 36px rgba(0,0,0,.24);backdrop-filter:blur(13px)}
    .catalog{display:flex;flex-direction:column;padding:13px;overflow:hidden}
    .panel-head{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:9px}
    .panel-head h2{margin:0;font:900 23px/1 Georgia,"Times New Roman",serif;color:#fff0b7}
    .panel-head p{margin:5px 0 0;font-size:10px;line-height:1.35;color:rgba(255,255,255,.68)}
    .count{flex:0 0 auto;padding:6px 9px;border:1px solid rgba(255,226,131,.31);border-radius:999px;background:rgba(255,215,92,.13);color:#ffe69b;font-size:10px;font-weight:950}
    .filters{display:grid;grid-template-columns:1fr;gap:7px;margin-bottom:9px}
    .light-field,.filters input,.filters select{
      width:100%;min-width:0;border:1px solid #d2c0d9!important;border-radius:12px!important;
      background:#fff!important;color:#24132c!important;-webkit-text-fill-color:#24132c!important;
      color-scheme:light!important;padding:10px 11px!important;font-size:12px!important;font-weight:750!important;
      outline:none!important;box-shadow:none!important;opacity:1!important;filter:none!important;text-shadow:none!important;
    }
    .filters input::placeholder,.light-field::placeholder{color:#75627a!important;-webkit-text-fill-color:#75627a!important;opacity:1!important}
    .filters select option,.light-field option{background:#fff!important;color:#24132c!important;-webkit-text-fill-color:#24132c!important}
    .list{flex:1;min-height:0;overflow:auto;display:flex;flex-direction:column;gap:7px;padding:1px 3px 2px 0;scrollbar-color:#c68bd8 rgba(255,255,255,.06)}
    .choice{display:grid;grid-template-columns:minmax(0,1fr) 38px;align-items:stretch;gap:7px;width:100%;min-height:64px;padding:6px 4px;border:0;border-radius:11px;background:transparent;color:#fff;transition:transform .14s ease,background .14s ease,box-shadow .14s ease}
    .choice:hover{transform:translateX(2px);background:linear-gradient(90deg,rgba(255,224,128,.14),rgba(255,224,128,.035));box-shadow:inset 3px 0 0 rgba(255,229,148,.72)}
    .choice.active{background:linear-gradient(90deg,rgba(255,220,99,.22),rgba(179,68,207,.10),transparent);box-shadow:inset 3px 0 0 #ffe087,0 0 18px rgba(255,195,65,.14)}
    .choice.in-cart{background:linear-gradient(90deg,rgba(82,230,137,.10),transparent);box-shadow:inset 3px 0 0 #8ff0b2,0 0 14px rgba(82,230,137,.12)}
    .choice-main{display:grid;grid-template-columns:54px minmax(0,1fr);align-items:center;gap:9px;width:100%;min-width:0;padding:1px 2px;border:0;background:transparent;color:#fff;text-align:left}
    .add-fu{align-self:stretch;min-width:38px;border:0;border-radius:50%;background:transparent;color:#fff5ca;font-size:23px;font-weight:1000;line-height:1;text-shadow:0 0 9px rgba(255,222,112,.42);transition:transform .14s ease,color .14s ease,filter .14s ease}
    .add-fu:hover{background:transparent;color:#fff;transform:scale(1.18);filter:drop-shadow(0 0 7px rgba(255,228,134,.92))}.add-fu.added{background:transparent;color:#9af0ad;border:0;font-size:18px;filter:drop-shadow(0 0 6px rgba(82,230,137,.68))}
    .thumb{width:54px;height:54px;display:grid;place-items:center;overflow:hidden;border-radius:10px;background:#f3d354;isolation:isolate;box-shadow:inset 0 0 0 1px rgba(255,247,184,.8)}
    .thumb img{display:block;width:100%;height:100%;object-fit:contain;object-position:center;background:transparent;mix-blend-mode:multiply;opacity:1;filter:contrast(1.08) saturate(1.08)}
    .choice b{display:block;color:#fff2c5;font-size:12px;line-height:1.18}
    .choice small{display:block;margin-top:3px;color:rgba(255,255,255,.66);font-size:9px;line-height:1.22}
    .preview{display:grid;grid-template-columns:minmax(240px,.78fr) minmax(300px,1.22fr);gap:12px;padding:12px;overflow:hidden}
    .image-side{min-width:0;min-height:0;display:flex;flex-direction:column;align-items:center;gap:7px;padding:6px;border-radius:17px;background:radial-gradient(circle at 50% 34%,rgba(255,237,164,.15),rgba(54,12,69,.11) 58%,rgba(0,0,0,.11));overflow:hidden}
    .image-stage{position:relative;width:100%;min-width:0;min-height:280px;flex:1 1 auto;display:grid;place-items:center;overflow:hidden;padding:8px}
    .image-stage::before,.image-stage::after{content:"";position:absolute;border-radius:50%;pointer-events:none}
    .image-stage::before{inset:8%;border:2px solid rgba(255,226,117,.42);box-shadow:0 0 24px rgba(255,215,81,.28),inset 0 0 22px rgba(255,226,126,.16);animation:ring 5s linear infinite}
    .image-stage::after{inset:18%;border:1px dashed rgba(213,123,255,.52);animation:ring-reverse 8s linear infinite}
    .paper{position:relative;z-index:2;display:block;width:min(78%,360px);aspect-ratio:2/3;overflow:hidden;background:#f3d354;isolation:isolate;border:1px solid rgba(255,244,176,.86);box-shadow:0 13px 23px rgba(0,0,0,.45),0 0 24px rgba(255,220,91,.31)}
    .paper img{display:block;width:100%;height:100%;object-fit:fill;object-position:center;background:transparent;mix-blend-mode:multiply;opacity:1;filter:contrast(1.08) saturate(1.08);transform:none}
    .no-image{position:relative;z-index:2;font:900 70px/1 Georgia,serif;color:#ffe49b;text-shadow:0 0 22px rgba(255,213,86,.5)}
    .image-hint{font-size:9px;color:rgba(255,255,255,.58);text-align:center}
    .detail{min-width:0;min-height:0;overflow:auto;padding:3px 4px 8px 0;scrollbar-color:#c68bd8 rgba(255,255,255,.06)}
    .code{display:inline-flex;padding:7px 11px;border-radius:999px;background:linear-gradient(135deg,#ffe58a,#d99630);color:#3c1a0d;font-size:13px;font-weight:1000;letter-spacing:.06em;box-shadow:0 5px 16px rgba(255,190,50,.24)}
    .names h3{margin:10px 0 3px;color:#fff2c5;font:900 clamp(24px,3vw,37px)/1.03 Georgia,"Times New Roman",serif}
    .names .zh{font-size:21px;line-height:1.15;color:#ffdf83;font-weight:900}
    .meta{display:flex;flex-wrap:wrap;gap:6px;margin-top:9px}
    .meta span{padding:5px 8px;border:1px solid rgba(255,236,177,.23);border-radius:999px;background:rgba(255,255,255,.06);font-size:9px;color:rgba(255,255,255,.77)}
    .purpose{margin-top:10px;padding:11px 12px;border:1px solid rgba(255,237,183,.19);border-radius:14px;background:rgba(255,255,255,.055);color:rgba(255,255,255,.88);font-size:11px;line-height:1.48;white-space:pre-wrap}
    .purpose b{display:block;margin-bottom:5px;color:#ffe59c;font-size:10px;letter-spacing:.08em;text-transform:uppercase}
    .checkout{margin-top:11px;padding:12px;border-radius:16px;background:linear-gradient(145deg,#fff9e9,#f4e4f7);color:#2d1633;box-shadow:0 10px 24px rgba(0,0,0,.25)}
    .checkout-top{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;color:#32143b}
    .checkout-top b{color:#32143b;font-size:13px}
    .stone-price{color:#7a2b64;font:900 21px/1 Georgia,serif;white-space:nowrap}
    .cart{margin:0 0 10px;padding:9px;border:1px solid #dfcfe3;border-radius:12px;background:#fff;color:#2d1633}
    .cart-head{display:flex;align-items:center;justify-content:space-between;gap:8px;color:#4d2057;font-size:10px;font-weight:950;text-transform:uppercase;letter-spacing:.05em}
    .cart-list{display:flex;flex-direction:column;gap:5px;margin-top:7px;max-height:126px;overflow:auto}
    .cart-line{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;gap:7px;padding:6px 7px;border-radius:9px;background:#f7eff8;color:#3c2141;font-size:10px}
    .cart-line b{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#3c2141}
    .cart-remove{width:25px;height:25px;border:0;border-radius:8px;background:#7b2c75;color:#fff;font-weight:1000}
    .cart-empty{margin-top:7px;color:#735f77;font-size:10px;line-height:1.35}
    .preview-add{width:100%;margin-top:9px;padding:8px 10px;border:1px solid #d4b35b;border-radius:10px;background:#fff4bd;color:#4d2b19;font-size:10px;font-weight:1000}
    .pouch-note{margin-top:5px;color:#725d76;font-size:9px;line-height:1.3;text-transform:none;letter-spacing:0}
    .field-label{display:grid;gap:6px;margin-top:9px;color:#32143b!important;-webkit-text-fill-color:#32143b!important;font-size:10px;font-weight:950;letter-spacing:.05em;text-transform:uppercase;text-shadow:none!important}
    .field-label span{color:#32143b!important;-webkit-text-fill-color:#32143b!important;font-weight:600;letter-spacing:0;text-transform:none}
    textarea.light-field{min-height:78px;resize:vertical;caret-color:#24132c}
    .request-btn{width:100%;margin-top:11px;padding:11px 13px;border:0;border-radius:12px;background:linear-gradient(180deg,#ff8a33,#e94b08);color:#fff!important;-webkit-text-fill-color:#fff!important;font-size:12px;font-weight:1000;letter-spacing:.06em;box-shadow:0 7px 15px rgba(190,54,0,.28)}
    .status{display:none;margin-top:9px;padding:9px 10px;border-radius:11px;font-size:10px;line-height:1.4;text-shadow:none}
    .status.show{display:block}.status.ok{background:#e8f6df;border:1px solid #afd09d;color:#244f20}.status.bad{background:#ffe5e5;border:1px solid #dca0a0;color:#6d2020}.status.work{background:#fff1c5;border:1px solid #d9bb64;color:#5a4216}
    .footer-actions{display:flex;justify-content:space-between;gap:8px;margin-top:9px}
    .text-btn{flex:1;border:1px solid rgba(96,35,108,.24);border-radius:10px;background:#fff;color:#572163;padding:7px 9px;font-size:10px;font-weight:950}
    .empty{padding:24px 12px;text-align:center;color:rgba(255,255,255,.68);font-size:12px}
    .busy{position:absolute;inset:0;z-index:90;display:grid;place-items:center;background:rgba(18,4,28,.55);backdrop-filter:blur(3px)}
    .busy-card{padding:15px 19px;border:1px solid rgba(255,231,151,.45);border-radius:15px;background:rgba(44,10,57,.94);color:#fff1bd;font-weight:950;box-shadow:0 12px 30px rgba(0,0,0,.38)}
    .modal{position:absolute;inset:0;z-index:100;display:grid;place-items:center;padding:18px;background:rgba(13,3,22,.74);backdrop-filter:blur(6px)}
    .modal-card{width:min(760px,96%);max-height:84%;overflow:auto;padding:16px;border:1px solid rgba(255,231,153,.56);border-radius:20px;background:#fffaf0;color:#2d1831;box-shadow:0 24px 60px rgba(0,0,0,.52);text-shadow:none}
    .modal-head{display:flex;align-items:center;justify-content:space-between;gap:10px}
    .modal-title{margin:0;color:#4a1556!important;-webkit-text-fill-color:#4a1556!important;font:900 25px/1 Georgia,serif;text-shadow:none!important}
    .close{width:36px;height:36px;border:0;border-radius:10px;background:#6c227f;color:#fff;font-size:20px;font-weight:950}
    .order-list{display:flex;flex-direction:column;gap:8px;margin-top:12px}
    .order{padding:10px 12px;border:1px solid #e1d5e4;border-radius:12px;background:#fff;color:#2d1831}
    .order b{display:block;color:#551f60;font-size:13px}.order small{display:block;margin-top:4px;color:#705e73;font-size:10px;line-height:1.45}
    @keyframes ring{to{transform:rotate(360deg)}} @keyframes ring-reverse{to{transform:rotate(-360deg)}}

    @media(max-width:1120px){
      .scene{min-height:710px;height:max(710px,calc(100dvh - 14px));border-radius:19px}
      .header{left:12px;right:12px;top:10px}.price-badge{left:12px;top:66px;padding:6px 10px;font-size:9px}
      .layout{left:9px;right:9px;top:99px;bottom:9px;grid-template-columns:minmax(245px,.66fr) minmax(0,1.44fr);gap:9px}
      .catalog{padding:9px}.panel-head p{display:none}.panel-head h2{font-size:20px}
      .choice{grid-template-columns:minmax(0,1fr) 34px;min-height:55px;padding:5px}.choice-main{grid-template-columns:46px minmax(0,1fr);gap:7px}.add-fu{min-width:34px}.thumb{width:46px;height:46px}
      .preview{grid-template-columns:minmax(210px,.72fr) minmax(260px,1.28fr);gap:8px;padding:8px}
      .image-stage{min-height:245px}.names h3{font-size:clamp(22px,3vw,30px)}.names .zh{font-size:18px}
      .checkout{padding:10px}.light-field,.filters input,.filters select{padding:8px 9px!important;font-size:11px!important}
    }
    @media(max-width:820px){
      .scene{height:auto;min-height:780px;max-height:none;overflow:auto}
      .header{position:relative;left:auto;right:auto;top:auto;padding:10px 9px 0}
      h1{font-size:24px}.icon-btn{width:36px;height:36px}
      .price-badge{position:relative;left:auto;top:auto;display:inline-flex;margin:7px 9px 0}
      .layout{position:relative;left:auto;right:auto;top:auto;bottom:auto;grid-template-columns:1fr;margin:8px 7px 10px}
      .catalog{height:340px}.preview{grid-template-columns:minmax(235px,.8fr) minmax(0,1.2fr);min-height:620px;overflow:hidden}
    }
    @media(max-width:620px){
      .preview{grid-template-columns:1fr;min-height:0;overflow:visible}.image-side{height:400px}.detail{overflow:visible}
      .catalog{height:320px}.checkout-top{align-items:flex-start;flex-direction:column}.footer-actions{flex-wrap:wrap}
    }

    :host([data-mode="public-cad"]) .scene{min-height:900px;height:900px}
    :host([data-mode="public-cad"]) .paper{max-height:100%;object-fit:contain}

    :host(.fullscreen){width:100vw;height:100dvh;background:#16051f;overflow:hidden}
    :host(.fullscreen) .scene{position:fixed;inset:0;width:100vw;height:100dvh;min-height:0;max-height:none;border-radius:0;overflow:hidden}
    :host(.fullscreen) .header{position:absolute;left:20px;right:20px;top:12px;padding:0}
    :host(.fullscreen) .price-badge{position:absolute;left:20px;top:72px;margin:0}
    :host(.fullscreen) .layout{position:absolute;left:14px;right:14px;top:106px;bottom:14px;margin:0;display:grid;grid-template-columns:minmax(290px,.74fr) minmax(0,1.66fr);gap:12px}
    :host(.fullscreen) .catalog{height:auto;padding:12px}
    :host(.fullscreen) .panel-head p{display:block}
    :host(.fullscreen) .preview{grid-template-columns:minmax(280px,.82fr) minmax(360px,1.18fr);min-height:0;overflow:hidden;padding:12px;gap:12px}
    :host(.fullscreen) .image-side{height:auto;overflow:hidden}
    :host(.fullscreen) .image-stage{height:calc(100dvh - 164px);min-height:0}
    :host(.fullscreen) .detail{overflow:auto}
    @media(max-width:900px){
      :host(.fullscreen) .layout{grid-template-columns:minmax(230px,.64fr) minmax(0,1.36fr)}
      :host(.fullscreen) .preview{grid-template-columns:minmax(210px,.72fr) minmax(250px,1.28fr)}
    }
    @media(max-width:720px){
      :host(.fullscreen) .preview{grid-template-columns:1fr;overflow-y:auto;align-content:start}
      :host(.fullscreen) .image-side{height:42dvh;min-height:280px}
      :host(.fullscreen) .image-stage{height:100%}
      :host(.fullscreen) .detail{overflow:visible}
    }
    @media(prefers-reduced-motion:reduce){.image-stage::before,.image-stage::after{animation:none}}
  `;

  class SlbAcFuRequest extends HTMLElement {
    constructor(){
      super();
      this.attachShadow({mode:'open'});
      this.state = {
        loading:false, loaded:false, busy:false,
        catalog:[], filtered:[], pouches:[], orders:[], cartIds:[],
        selectedId:'', query:'', book:'ALL', pouchId:'', note:'',
        showOrders:false, error:'', result:null, pouchLoading:true
      };
      this.publicCad = clean(this.getAttribute('data-mode')).toLowerCase() === 'public-cad' || this.hasAttribute('data-public-cad');
      this.publicPrice = Math.max(1, Math.round(num(this.getAttribute('data-price')) || 108));
      this._bound = false;
      this._resizeObserver = null;
    }
    connectedCallback(){
      if(!this._bound){ this._bind(); this._bound = true; }
      this.publicCad = clean(this.getAttribute('data-mode')).toLowerCase() === 'public-cad' || this.hasAttribute('data-public-cad');
      this.publicPrice = Math.max(1, Math.round(num(this.getAttribute('data-price')) || 108));
      this._loadPreferences();
      if(this.publicCad){ this.state.pouches=[]; this.state.pouchId=''; this.state.pouchLoading=false; }
      else { this.state.pouches = pouchesFromApp(); if(this.state.pouches.length) this.state.pouchLoading = false; }
      this.render();
      this.load(false).catch(function(){});
    }
    disconnectedCallback(){ if(this._resizeObserver){ try{ this._resizeObserver.disconnect(); }catch(_e){} this._resizeObserver = null; } }
    _bind(){
      var self = this;
      this.shadowRoot.addEventListener('click', function(event){ self._click(event); });
      this.shadowRoot.addEventListener('input', function(event){ self._input(event); });
      this.shadowRoot.addEventListener('change', function(event){ self._change(event); });
      document.addEventListener('fullscreenchange', function(){ self._fullscreenChanged(); });
      document.addEventListener('webkitfullscreenchange', function(){ self._fullscreenChanged(); });
      window.addEventListener('resize', function(){ self.fitImage(); });
      if(window.ResizeObserver){ this._resizeObserver = new ResizeObserver(function(){ self.fitImage(); }); this._resizeObserver.observe(this); }
    }
    _loadPreferences(){
      var key=this.publicCad ? PREF_KEY+'_public_cad' : PREF_KEY;
      var pref = readJson(key, {}) || {};
      this.state.book = clean(pref.book) || 'ALL';
      this.state.pouchId = this.publicCad ? '' : clean(pref.pouchId);
      this.state.cartIds = Array.isArray(pref.cartIds) ? pref.cartIds.map(clean).filter(Boolean) : [];
    }
    _savePreferences(){ var key=this.publicCad ? PREF_KEY+'_public_cad' : PREF_KEY; writeJson(key, {book:this.state.book, pouchId:this.publicCad?'':this.state.pouchId, cartIds:this.state.cartIds.slice(0,50)}); }
    selected(){
      var id = clean(this.state.selectedId);
      for(var i=0;i<this.state.catalog.length;i++) if(clean(this.state.catalog[i].itemId) === id) return this.state.catalog[i];
      return null;
    }
    itemById(id){
      id = clean(id);
      for(var i=0;i<this.state.catalog.length;i++) if(clean(this.state.catalog[i].itemId) === id) return this.state.catalog[i];
      return null;
    }
    cartItems(){
      var self=this, out=[];
      this.state.cartIds.forEach(function(id){ var item=self.itemById(id); if(item) out.push(item); });
      return out;
    }
    inCart(id){ return this.state.cartIds.indexOf(clean(id)) >= 0; }
    toggleCart(id){
      id=clean(id); if(!id) return;
      var pos=this.state.cartIds.indexOf(id);
      if(pos<0 && this.publicCad){ var candidate=this.itemById(id); if(candidate && !clean(candidate.imageUrl)){ this.state.error=(candidate.code||id)+' is missing its FU image in the FU Book data and cannot be ordered yet.'; this.state.result=null; this.render(); return; } }
      if(pos>=0) this.state.cartIds.splice(pos,1); else this.state.cartIds.push(id);
      this.state.error=''; this.state.result=null; this._savePreferences(); this.render();
    }
    books(){
      var seen = Object.create(null), out = [];
      this.state.catalog.forEach(function(item){ var book = clean(item.sourceBook) || 'FU Library'; if(!seen[book]){ seen[book] = true; out.push(book); } });
      return out.sort(function(a,b){ return a.localeCompare(b, 'en', {numeric:true, sensitivity:'base'}); });
    }
    applyFilter(){
      var q = clean(this.state.query).toLowerCase();
      var book = this.state.book;
      this.state.filtered = this.state.catalog.filter(function(item){
        if(book !== 'ALL' && clean(item.sourceBook) !== book) return false;
        if(!q) return true;
        return [item.code,item.englishTitle,item.chineseTitle,item.purpose,item.sourceBook,item.category].join(' ').toLowerCase().indexOf(q) >= 0;
      });
      var current = this.selected();
      if(!current || this.state.filtered.indexOf(current) < 0) this.state.selectedId = this.state.filtered.length ? clean(this.state.filtered[0].itemId) : '';
    }
    bookOptions(){
      var self = this;
      return '<option value="ALL">All FU Books</option>' + this.books().map(function(book){ return '<option value="'+esc(book)+'" '+(self.state.book===book?'selected':'')+'>'+esc(book)+'</option>'; }).join('');
    }
    pouchOptions(){
      var self = this;
      var first = this.state.pouchLoading ? 'Loading stone pouches…' : (this.state.pouches.length ? 'Choose a stone pouch…' : 'No active stone pouch found');
      return '<option value="">'+esc(first)+'</option>' + this.state.pouches.map(function(pouch){
        var id = pouchIdOf(pouch);
        var name = clean(pouch.name || pouch.label || id);
        return '<option value="'+esc(id)+'" '+(self.state.pouchId===id?'selected':'')+'>'+esc(name)+' — '+fmt(pouch.balance)+' stones</option>';
      }).join('');
    }
    choice(item){
      var active = clean(item.itemId) === clean(this.state.selectedId);
      var added = this.inCart(item.itemId);
      var image = clean(item.imageUrl);
      return '<div class="choice '+(active?'active ':'')+(added?'in-cart':'')+'">'+
        '<button type="button" class="choice-main" data-select="'+esc(item.itemId)+'" aria-pressed="'+(active?'true':'false')+'">'+
        '<span class="thumb">'+(image?'<img src="'+esc(image)+'" alt="" loading="lazy">':'<b>FU</b>')+'</span>'+
        '<span><b>'+esc(item.code)+' · '+esc(item.englishTitle || 'FU')+'</b><small>'+esc(item.chineseTitle)+(item.sourceBook?' · '+esc(item.sourceBook):'')+'</small></span></button>'+
        '<button type="button" class="add-fu '+(added?'added':'')+'" data-cart="'+esc(item.itemId)+'" title="'+(added?'Remove from request':'Add to request')+'" aria-label="'+(added?'Remove this FU from request':'Add this FU to request')+'">'+(added?'✓':'+')+'</button></div>';
    }
    status(){
      var s=this.state, count=this.cartItems().length, total=count*(this.publicCad?this.publicPrice:108);
      if(this.publicCad){
        if(s.busy) return '<div class="status show work">Adding '+fmt(count)+' FU'+(count===1?'':'s')+' to the Celestial Altar…</div>';
        if(s.error) return '<div class="status show bad">'+esc(s.error)+'</div>';
        if(s.result) return '<div class="status show ok"><b>FU added to the altar.</b> You can move it on the table before finishing your visit.</div>';
        return '<div class="status"></div>';
      }
      if(s.busy) return '<div class="status show work">Submitting '+fmt(count)+' FU request'+(count===1?'':'s')+' and charging '+fmt(total)+' stones…</div>';
      if(s.error) return '<div class="status show bad">'+esc(s.error)+'</div>';
      if(s.result){
        var ids = Array.isArray(s.result.orderIds) ? s.result.orderIds.join(', ') : '';
        var mail = clean(s.result.emailStatus).toUpperCase();
        var charged = num(s.result.totalOffer || s.result.charged || 0);
        var ordered = Array.isArray(s.result.orderIds) ? s.result.orderIds.length : num(s.result.itemCount || 0);
        var sentence = mail === 'SENT' ? 'The email ticket was sent to Jee Sifu.' : (mail === 'QUEUED' || mail === 'PENDING' ? 'The request is recorded and email delivery is queued.' : 'The request is recorded in the backend.');
        return '<div class="status show ok"><b>Request submitted.</b> '+fmt(charged)+' stones were charged for '+fmt(ordered)+' FU'+(ordered===1?'':'s')+'. '+esc(sentence)+(ids?'<br>Tickets: '+esc(ids):'')+'</div>';
      }
      return '<div class="status"></div>';
    }
    cartHtml(){
      var items=this.cartItems(), unit=this.publicCad?this.publicPrice:108, suffix=this.publicCad?' CAD':' stones';
      if(!items.length) return '<div class="cart"><div class="cart-head"><span>Selected FU</span><b>0</b></div><div class="cart-empty">Use the + button beside any FU to add it to this request.</div></div>';
      return '<div class="cart"><div class="cart-head"><span>Selected FU</span><b>'+fmt(items.length)+' · '+(this.publicCad?'$':'')+fmt(items.length*unit)+suffix+'</b></div><div class="cart-list">'+items.map(function(item){ return '<div class="cart-line"><b>'+esc(item.code)+' · '+esc(item.englishTitle||'FU')+'</b><button type="button" class="cart-remove" data-cart="'+esc(item.itemId)+'" aria-label="Remove '+esc(item.code)+'">×</button></div>'; }).join('')+'</div></div>';
    }
    preview(){
      var item = this.selected();
      if(!item) return '<section class="panel preview"><div class="empty">Choose a FU from the Library.</div></section>';
      var image=clean(item.imageUrl), added=this.inCart(item.itemId), count=this.cartItems().length, unit=this.publicCad?this.publicPrice:108, total=count*unit;
      var checkoutTitle=this.publicCad?'Celestial Altar FU Selection':'AC FU Checkout';
      var totalLabel=this.publicCad?('$'+fmt(total)+' CAD'):(fmt(total)+' Stones');
      var metaMode=this.publicCad?'Celestial Altar':'AC Request';
      var payment=this.publicCad?'':'<label class="field-label">Pay from stone pouch<select class="light-field" data-pouch '+(this.state.pouchLoading?'disabled':'')+'>'+this.pouchOptions()+'</select><span class="pouch-note">'+(this.state.pouches.length?'Choose the pouch used for the whole request.':'SLB is checking your active pouches automatically.')+'</span></label>';
      var buttonLabel=this.publicCad?('ADD '+fmt(count)+' FU'+(count===1?'':'S')+' TO ALTAR · $'+fmt(total)+' CAD'):('CHECK OUT '+fmt(count)+' FU'+(count===1?'':'S'));
      var disabled=this.state.busy||!count||(!this.publicCad&&this.state.pouchLoading);
      return '<section class="panel preview">'+
        '<div class="image-side"><div class="image-stage">'+(image?'<span class="paper"><img class="main-image" src="'+esc(image)+'" alt="'+esc(item.imageAlt || item.title)+'" loading="eager" decoding="async"></span>':'<div class="no-image">IMAGE NOT AVAILABLE</div>')+'</div><div class="image-hint">FU image from '+esc(item.sourceBook || 'the Lineage Library')+'</div></div>'+ 
        '<div class="detail"><span class="code">'+esc(item.code)+'</span><div class="names"><h3>'+esc(item.englishTitle || 'FU')+'</h3><div class="zh">'+esc(item.chineseTitle)+'</div></div>'+ 
        '<div class="meta"><span>'+esc(item.sourceBook || 'FU Library')+'</span><span>'+esc(item.category || 'FU')+'</span><span>'+metaMode+'</span></div>'+ 
        '<div class="purpose"><b>FU Purpose</b>'+esc(item.purpose || 'Purpose information is not available for this FU yet.')+'</div>'+ 
        '<button type="button" class="preview-add" data-cart="'+esc(item.itemId)+'">'+(added?(this.publicCad?'REMOVE THIS FU FROM ALTAR LIST':'REMOVE THIS FU FROM ORDER'):(this.publicCad?'ADD THIS FU TO ALTAR':'ADD THIS FU TO ORDER'))+'</button>'+ 
        '<div class="checkout"><div class="checkout-top"><b>'+checkoutTitle+'</b><span class="stone-price">'+totalLabel+'</span></div>'+this.cartHtml()+payment+
        '<label class="field-label">Request note <span>(optional)</span><textarea class="light-field" data-note maxlength="2000" placeholder="Add one short note for this whole FU request…">'+esc(this.state.note)+'</textarea></label>'+ 
        '<button type="button" class="request-btn" data-request '+(disabled?'disabled':'')+'>'+(this.state.busy?'SUBMITTING…':buttonLabel)+'</button>'+this.status()+
        '<div class="footer-actions">'+(this.publicCad?'<button type="button" class="text-btn" data-return>Return to Altar</button>':'<button type="button" class="text-btn" data-orders>My Requests</button>')+'<button type="button" class="text-btn" data-clear>Clear Cart</button></div></div></div></section>';
    }
    orderModal(){
      if(!this.state.showOrders) return '';
      var body = this.state.orders.length ? this.state.orders.map(function(order){
        var date = ''; try { date = order.timeISO ? new Date(order.timeISO).toLocaleString() : ''; } catch(_e){}
        return '<div class="order"><b>'+esc(order.title || order.itemId || 'FU')+'</b><small>'+esc(date)+' · '+fmt(order.offering || 108)+' stones · '+esc(clean(order.status || 'NEW').toUpperCase())+(order.emailStatus?' · EMAIL '+esc(clean(order.emailStatus).toUpperCase()):'')+(order.note?'<br>'+esc(order.note):'')+'</small></div>';
      }).join('') : '<div class="empty" style="color:#725e78">No FU requests yet.</div>';
      return '<div class="modal" data-modal><div class="modal-card"><div class="modal-head"><h3 class="modal-title">My AC FU Requests</h3><button type="button" class="close" data-close>×</button></div><div class="order-list">'+body+'</div></div></div>';
    }
    render(options){
      options = options || {};
      this.applyFilter();
      var list = this.state.filtered.length ? this.state.filtered.map(this.choice.bind(this)).join('') : '<div class="empty">No FU matches this search.</div>';
      this.shadowRoot.innerHTML = '<style>'+STYLE+'</style><div class="scene" style="background-image:url(\''+esc(BACKGROUND)+'\')">'+
        '<header class="header"><div><div class="kicker">'+(this.publicCad?'Celestial Altar · Public FU Book':'Ancestral Court · Stone Request')+'</div><h1>'+(this.publicCad?'Browse & Add FU Talismans':'Request FU from AC')+'</h1></div><div class="controls"><button type="button" class="icon-btn" data-full title="Fullscreen" aria-label="Toggle fullscreen">⛶</button></div></header>'+
        '<div class="price-badge">'+(this.publicCad?('ALL FU · $'+fmt(this.publicPrice)+' CAD EACH'):'ALL FU REQUESTS · 108 STONES EACH')+'</div>'+
        '<main class="layout"><aside class="panel catalog"><div class="panel-head"><div><h2>FU Library</h2><p>Select a FU Book, read its purpose, and inspect the complete FU image.</p></div><span class="count">'+fmt(this.state.filtered.length)+' / '+fmt(this.state.catalog.length)+'</span></div>'+
        '<div class="filters"><input type="search" data-search value="'+esc(this.state.query)+'" placeholder="Search code, name, purpose…"><select data-book>'+this.bookOptions()+'</select></div><div class="list">'+list+'</div></aside>'+this.preview()+'</main>'+this.orderModal()+(this.state.loading&&!this.state.loaded?'<div class="busy"><div class="busy-card">Opening the AC FU Library…</div></div>':'')+'</div>';
      var self = this;
      requestAnimationFrame(function(){ self.fitImage(); });
      setTimeout(function(){ self.fitImage(); }, 120);
      setTimeout(function(){ self.fitImage(); }, 500);
      if(options.focusSearch){
        requestAnimationFrame(function(){
          var input = self.shadowRoot.querySelector('[data-search]');
          if(input){ try { input.focus(); input.setSelectionRange(options.position, options.position); } catch(_e){} }
        });
      }
    }
    fitImage(){
      var stage = this.shadowRoot && this.shadowRoot.querySelector('.image-stage');
      var paper = this.shadowRoot && this.shadowRoot.querySelector('.paper');
      var image = this.shadowRoot && this.shadowRoot.querySelector('.main-image');
      if(!stage || !paper || !image) return;
      var self = this;
      function apply(){
        var nw = num(image.naturalWidth), nh = num(image.naturalHeight);
        var rect = stage.getBoundingClientRect();
        if(!nw || !nh || rect.width < 80 || rect.height < 100) return false;
        var maxW = Math.max(80, rect.width * .90), maxH = Math.max(120, rect.height * .94);
        var scale = Math.min(maxW / nw, maxH / nh);
        paper.style.width = Math.max(1, Math.floor(nw * scale)) + 'px';
        paper.style.height = Math.max(1, Math.floor(nh * scale)) + 'px';
        return true;
      }
      if(!apply() && !image.__fitBound){
        image.__fitBound = true;
        image.addEventListener('load', function(){ requestAnimationFrame(apply); }, {once:true});
      }
      clearTimeout(this._fitTimer);
      this._fitTimer = setTimeout(function(){ apply(); }, 80);
    }
    _click(event){
      var target = event.target && event.target.closest ? event.target.closest('button,[data-modal]') : null;
      if(!target) return;
      if(target.hasAttribute('data-select')){ this.state.selectedId = clean(target.getAttribute('data-select')); this.state.error=''; this.state.result=null; this.render(); return; }
      if(target.hasAttribute('data-cart')){ this.toggleCart(target.getAttribute('data-cart')); return; }
      if(target.hasAttribute('data-full')){ this.toggleFullscreen(); return; }
      if(target.hasAttribute('data-request')){ this.submit(); return; }
      if(target.hasAttribute('data-orders')){ this.state.showOrders=true; this.render(); this.loadOrders(); return; }
      if(target.hasAttribute('data-close')){ this.state.showOrders=false; this.render(); return; }
      if(target.hasAttribute('data-clear')){ this.state.cartIds=[]; this.state.note=''; this.state.error=''; this.state.result=null; this._savePreferences(); this.render(); return; }
      if(target.hasAttribute('data-return')){ if(this.publicCad&&this.cartItems().length){ this.submit(); return; } try{ this.dispatchEvent(new CustomEvent('slb-ac-fu-public-return',{bubbles:true,composed:true})); }catch(_e){} return; }
      if(target.hasAttribute('data-modal') && event.target === target){ this.state.showOrders=false; this.render(); }
    }
    _input(event){
      var target = event.target;
      if(target.hasAttribute('data-search')){
        var pos = num(target.selectionStart || clean(target.value).length);
        this.state.query = target.value || '';
        this.render({focusSearch:true,position:pos});
      } else if(target.hasAttribute('data-note')) this.state.note = target.value || '';
    }
    _change(event){
      var target = event.target;
      if(target.hasAttribute('data-book')){ this.state.book = target.value || 'ALL'; this._savePreferences(); this.render(); }
      else if(target.hasAttribute('data-pouch')){ this.state.pouchId = target.value || ''; this._savePreferences(); }
    }
    toggleFullscreen(){
      var current = document.fullscreenElement || document.webkitFullscreenElement || null;
      if(current === this || this.classList.contains('fullscreen')){
        if(current){
          try { if(document.exitFullscreen) return document.exitFullscreen(); if(document.webkitExitFullscreen) return document.webkitExitFullscreen(); } catch(_e){}
        }
        this.classList.remove('fullscreen'); this.fitImage(); return;
      }
      this.classList.add('fullscreen');
      try {
        var promise = this.requestFullscreen ? this.requestFullscreen() : (this.webkitRequestFullscreen ? this.webkitRequestFullscreen() : null);
        if(promise && typeof promise.catch === 'function') promise.catch(function(){});
      } catch(_e){}
      this.fitImage();
    }
    _fullscreenChanged(){
      var current = document.fullscreenElement || document.webkitFullscreenElement || null;
      if(current === this) this.classList.add('fullscreen'); else this.classList.remove('fullscreen');
      this.fitImage();
    }
    loadOrders(){
      var self = this;
      return rpc('templeMyOrders',{limit:100,showArchived:0},{cacheTtlMs:0,progressMode:'silent'}).then(function(rows){ self.state.orders = Array.isArray(rows) ? rows : []; if(self.state.showOrders) self.render(); return self.state.orders; }).catch(function(){ return []; });
    }
    _applyPouches(rows){
      rows=normalizePouches(rows);
      if(!rows.length) rows=pouchesFromApp();
      this.state.pouches=rows;
      this.state.pouchLoading=false;
      if(this.state.pouchId && !rows.some(function(p){ return pouchIdOf(p).toLowerCase() === clean(this.state.pouchId).toLowerCase(); },this)) this.state.pouchId='';
      if(!this.state.pouchId && rows.length) this.state.pouchId=pouchIdOf(rows[0]);
      this._savePreferences();
    }
    _recoverPouches(){
      var self=this, a=app();
      if(a && typeof a.refreshDashboardLite==='function'){
        try{
          var refreshed=a.refreshDashboardLite({forceFresh:1});
          if(refreshed && typeof refreshed.then==='function') return refreshed.then(function(){ self._applyPouches(pouchesFromApp()); self.render(); return self.state.pouches; }).catch(function(){ return self.state.pouches; });
        }catch(_e){}
      }
      self._applyPouches(pouchesFromApp()); self.render();
      return Promise.resolve(self.state.pouches);
    }
    load(force){
      var self = this;
      if(this.state.loading) return Promise.resolve(true);
      this.state.loading = true;
      this.state.pouchLoading = this.publicCad ? false : !this.state.pouches.length;
      var local=localCatalog(), cache=readJson(CACHE_KEY,null);
      if(local.length){ this.state.catalog=local; this.state.loaded=true; writeJson(CACHE_KEY,{version:libraryVersion(),catalog:local,savedAt:Date.now()}); }
      else if(cache && Array.isArray(cache.catalog) && cache.catalog.length){ this.state.catalog=cache.catalog; this.state.loaded=true; }
      this.state.cartIds=this.state.cartIds.filter(function(id){ return !!self.itemById(id); });
      if(!this.state.selectedId && this.state.catalog.length) this.state.selectedId=clean(this.state.catalog[0].itemId);
      if(this.publicCad){
        this.state.pouches=[]; this.state.pouchId=''; this.state.pouchLoading=false; this.state.loading=false; this.state.loaded=!!this.state.catalog.length;
        this.state.error=this.state.loaded?'':'The FU Book could not be loaded.'; this.render(); return Promise.resolve(this.state.loaded);
      }
      var fallback=pouchesFromApp(); if(fallback.length) this._applyPouches(fallback); this.render();
      return rpc('templeGet',{}, {cacheTtlMs:0,noCacheFirst:true,progressMode:'silent',timeoutMs:90000}).then(function(out){
        out=out||{}; var latestLocal=localCatalog(), serverCatalog=out.fuCatalog||out.catalog||[];
        if(latestLocal.length){ self.state.catalog=latestLocal; writeJson(CACHE_KEY,{version:libraryVersion(),catalog:latestLocal,savedAt:Date.now()}); }
        else if(Array.isArray(serverCatalog)&&serverCatalog.length){ self.state.catalog=serverCatalog; writeJson(CACHE_KEY,{version:clean(out.fuCatalogVersion),catalog:serverCatalog,savedAt:Date.now()}); }
        self.state.cartIds=self.state.cartIds.filter(function(id){ return !!self.itemById(id); }); self._applyPouches(out.pouches||out.accounts||[]);
        if(!self.state.selectedId && self.state.catalog.length) self.state.selectedId=clean(self.state.catalog[0].itemId);
        self.state.loading=false; self.state.loaded=true; self.state.error=''; self.render(); self.loadOrders(); if(!self.state.pouches.length)setTimeout(function(){self._recoverPouches();},350); return true;
      }).catch(function(error){
        self.state.loading=false; self.state.pouchLoading=false; self._applyPouches(pouchesFromApp()); self.state.error=self.state.pouches.length?'':clean(error&&error.message||error||'The FU Library could not be loaded.'); self.render(); if(!self.state.pouches.length)setTimeout(function(){self._recoverPouches();},350); if(!self.state.loaded)throw error; return false;
      });
    }
    submit(){
      var self=this, items=this.cartItems();
      if(this.state.busy) return;
      if(!items.length){ this.state.error='Add at least one FU with the + button.'; this.render(); return; }
      if(this.publicCad){
        var missing=items.filter(function(item){return !clean(item.imageUrl);});
        if(missing.length){ this.state.error=(missing[0].code||missing[0].itemId)+' is missing its FU image in the FU Book data and cannot be ordered yet.'; this.render(); return; }
        var total=items.length*this.publicPrice, requestNote=this.state.note||'', detailItems=items.map(function(item){ return {itemId:item.itemId,libraryItemId:item.libraryItemId,code:item.code,englishTitle:item.englishTitle,chineseTitle:item.chineseTitle,title:item.title,purpose:item.purpose,imageUrl:item.imageUrl,sourceBook:item.sourceBook,category:item.category,price:self.publicPrice}; });
        this.state.busy=true; this.state.error=''; this.state.result=null; this.render();
        setTimeout(function(){ self.state.busy=false; self.state.note=''; self.state.cartIds=[]; self.state.result={done:true,itemCount:detailItems.length,total:total}; self._savePreferences(); self.render(); try{self.dispatchEvent(new CustomEvent('slb-ac-fu-public-order',{detail:{items:detailItems,note:requestNote,unitPrice:self.publicPrice,total:total},bubbles:true,composed:true}));}catch(_e){} },0);
        return;
      }
      if(!this.state.pouchId){ this.state.error='Choose a stone pouch to pay from.'; this.render(); this._recoverPouches(); return; }
      var total=items.length*108, pouch=this.state.pouches.filter(function(p){ return pouchIdOf(p)===self.state.pouchId; })[0]||null;
      if(pouch && num(pouch.balance)<total){ this.state.error='That pouch does not have enough stones for '+fmt(items.length)+' FU ('+fmt(total)+' stones).'; this.render(); return; }
      this.state.busy=true; this.state.error=''; this.state.result=null; this.render();
      rpc('templeOrderCreateBulk',{pouchId:this.state.pouchId,note:this.state.note || '',lines:items.map(function(item){ return {itemId:item.libraryItemId || item.itemId,qty:1,note:'',flyFu:0}; })},{cacheTtlMs:0,noCacheFirst:true,timeoutMs:120000}).then(function(out){
        self.state.busy=false; self.state.note=''; self.state.cartIds=[]; self.state.result=out || {done:true,totalOffer:total,itemCount:items.length}; self.state.error=''; self._savePreferences(); self.render(); self.loadOrders();
        try { var a=app(); if(a && typeof a.refreshDashboardLite==='function') a.refreshDashboardLite({forceFresh:1}); } catch(_e){}
        setTimeout(function(){ self.load(true).catch(function(){}); }, 500);
      }).catch(function(error){ self.state.busy=false; self.state.error=clean(error && error.message || error || 'The FU request could not be submitted.'); self.render(); });
    }

  }

  if(!window.customElements.get(HOST_TAG)) window.customElements.define(HOST_TAG, SlbAcFuRequest);

  function host(){ return document.querySelector(HOST_TAG); }
  var api = {
    __acFuRequestV72:true,
    tagName:HOST_TAG,
    reload:function(){ var h=host(); return h ? h.load(false) : Promise.resolve(false); },
    refresh:function(){ var h=host(); return h ? h.load(true) : Promise.resolve(false); },
    state:function(){ var h=host(); return h ? h.state : null; }
  };
  window.SLB_AC_FU_REQUEST = api;
  window.SLB_TEMPLE = api;
})(window, document);
